// #region Imports

/* Telestream */
import { splitPath } from '../../components/file-toolbar/utilities/path.utils';

// #endregion Imports

// #region Constants

const MAX_RECENT_FILE_LIST_LENGTH = 10;

// #endregion Constants

/**
 * This is a UI utility function that will convert the long list of non-unique
 * entries in the history list into a short list of the most recently opened files.
 *
 * @param {Array<any>} history
 */
export function toRecentFileList(history, length) {
  const seen = {};

  const historyModels = history
    .filter(entry => entry.path != undefined)
    .filter(entry => Object.prototype.hasOwnProperty.call(seen, entry.path) ? false : (seen[entry.path] = true))
    .map(entry => {
      return {
        path: entry.path,
        open: entry.open
      };
    })
    .slice(0, length || MAX_RECENT_FILE_LIST_LENGTH);

  return historyModels.map((history) => {
    return {
      ...splitPath(history.path),
      path: history.path,
      open: history.open
    };
  });
}
